import React, { useState } from "react";
import { useTenant } from "../context/TenantContext";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";
import "../styles/faq.css";

const FAQ = () => {
  const { tenant } = useTenant();
  const [openIndex, setOpenIndex] = useState(null);

  const parseFAQContent = () => {
    // Get content from tenant (already saved from admin settings)
    const content = tenant?.faqContent;

    if (!content || content.trim() === "") {
      // Default FAQs if no content
      return [
        {
          question: "What is your return policy?",
          answer:
            "We accept returns within 30 days of purchase. Items must be unused and in original packaging.",
        },
        {
          question: "How long does shipping take?",
          answer:
            "Shipping typically takes 3-7 business days depending on your location.",
        },
        {
          question: "Do you offer international shipping?",
          answer: "Currently we ship within South Africa only.",
        },
        {
          question: "How can I track my order?",
          answer:
            "Once your order ships, you'll receive a tracking number via email.",
        },
        {
          question: "What payment methods do you accept?",
          answer:
            "We accept Visa, Mastercard, PayPal, and other major payment methods.",
        },
      ];
    }

    // Parse pipe-separated format: Question | Answer
    const faqs = [];
    const lines = content.split("\n");

    for (const line of lines) {
      if (line.trim()) {
        const [question, answer] = line.split("|");
        if (question && answer) {
          faqs.push({
            question: question.trim(),
            answer: answer.trim(),
          });
        }
      }
    }

    return faqs;
  };

  const faqs = parseFAQContent();

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="faq-page">
      <div className="container">
        <section className="faq-hero">
          <h1>Frequently Asked Questions</h1>
          <p>
            Find answers to common questions about our store, products, and
            policies.
          </p>
        </section>

        <div className="faq-list">
          {faqs.length > 0 ? (
            faqs.map((faq, index) => (
              <div
                key={index}
                className={`faq-item ${openIndex === index ? "open" : ""}`}
              >
                <button
                  className="faq-question"
                  onClick={() => toggleFAQ(index)}
                >
                  <span>{faq.question}</span>
                  {openIndex === index ? <FiChevronUp /> : <FiChevronDown />}
                </button>
                <div className="faq-answer">
                  <p>{faq.answer}</p>
                </div>
              </div>
            ))
          ) : (
            <div className="faq-empty">
              <p>No FAQ items available. Please check back later.</p>
            </div>
          )}
        </div>

        <div className="faq-contact">
          <h3>Still have questions?</h3>
          <p>Can't find what you're looking for? Contact our support team.</p>
          <a href="/contact" className="contact-btn">
            Contact Support
          </a>
        </div>
      </div>
    </div>
  );
};

export default FAQ;
